import { DASHBOARD_ASSISTANT_RUNTIME_MODE } from '../constants';
import { serializeSearchContact } from './serializers';

function getSearchResultCount(searchResult) {
  return Object.values(searchResult.results || {}).reduce(
    (total, items) => total + (Array.isArray(items) ? items.length : 0),
    0,
  );
}

function compactSearchItems(items = [], fields = []) {
  return items.slice(0, 3).map((item) =>
    fields.reduce((result, field) => {
      if (item[field] !== undefined && item[field] !== null && item[field] !== '') {
        result[field] = item[field];
      }
      return result;
    }, {}),
  );
}

export function createCompactSearchToolResult(searchResult, { alreadyDisplayed = false } = {}) {
  return {
    runtimeMode: DASHBOARD_ASSISTANT_RUNTIME_MODE,
    status: 'ok',
    query: searchResult.query,
    organizationName: searchResult.organizationName,
    timezone: searchResult.timezone,
    timezoneOffset: searchResult.timezoneOffset,
    resultCount: getSearchResultCount(searchResult),
    alreadyDisplayed,
    guidance:
      'Use these results to answer the user now. Do not call search_dashboard_records again for the same query unless the user explicitly asks for a new search.',
    topResults: {
      contacts: compactSearchItems(searchResult.results.contacts, ['contactId', 'name', 'email']),
      payments: compactSearchItems(searchResult.results.recentPayments, [
        'transactionId',
        'contactId',
        'donorName',
        'email',
        'totalCharged',
        'state',
        'timestamp',
        'timestampFormatted',
      ]),
      subscriptions: compactSearchItems(searchResult.results.subscriptions, [
        'subscriptionId',
        'contactId',
        'donorName',
        'email',
        'totalCharged',
        'status',
        'frequency',
      ]),
      forms: compactSearchItems(searchResult.results.forms, ['formId', 'name', 'type']),
      elements: compactSearchItems(searchResult.results.elements, ['elementId', 'name', 'type']),
    },
  };
}

export function buildSearchResult({ contacts = [], organizationName, query }) {
  return {
    runtimeMode: DASHBOARD_ASSISTANT_RUNTIME_MODE,
    status: 'ok',
    query,
    organizationName,
    results: {
      contacts: contacts.map(serializeSearchContact),
      paymentContacts: [],
      subscriptionContacts: [],
      recentPayments: [],
      subscriptions: [],
      forms: [],
      elements: [],
    },
  };
}
